import { FormattedMessage } from 'react-intl';
import { DateInterest } from '../../types';
import { acceptedSpan } from '../span';
import DateRange from '@/shared/i18n/components/DateRange';

interface Props {
  interest: DateInterest;
  detail?: 'span' | 'full';
}

export default function DateInterestSummary({ interest, detail = 'span' }: Props) {
  const { start, end } = acceptedSpan(interest);

  if (detail === 'span') return <DateRange start={start} end={end} />;

  return (
    <>
      {interest.accept.map((range) => (
        <span key={`${range.from}-${range.to}`} className="block">
          <DateRange start={range.from} end={range.to} />
        </span>
      ))}
      {interest.exclude.length > 0 && (
        <span className="block text-xs text-slate-500">
          <FormattedMessage
            id="accounts.dateInterest.blackouts"
            values={{ count: interest.exclude.length }}
          />
        </span>
      )}
    </>
  );
}
